import { render, staticRenderFns } from "./ConfirmDelete2.vue?vue&type=template&id=59360e7f&"
import script from "./ConfirmDelete2.vue?vue&type=script&lang=js&"
export * from "./ConfirmDelete2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports